<template>
  <MainContent>
    <IAMSmartProfileResultProvider
      @success="success"
      @error="error"
      :business-id="businessId"
    >
      <div>
        <b-card no-body v-if="!show">
          <nx-bform>
            <h5>{{$t('invitationCode')}}</h5>
            <nx-bform-server-errors name="server-errors" />
            <b-input-group>
              <b-form-input
                v-model="invitationCode"
                :placeholder="$t('placeholder')"
              />
            </b-input-group>

            <b-form-group class="mt-2 justify-content-end">
              <b-button
                class="bd-button mr-2"
                @click="confirm(businessId)"
                >{{$t('confirm')}}</b-button
              >
              <b-button variant="danger" @click="back"
                >{{$t('cancel')}}</b-button
              >
            </b-form-group>
          </nx-bform>
        </b-card>
        <b-card no-body v-if="show">
          <b-card-header class="header">
            {{ $t("title") }}
          </b-card-header>
          <h5 class="mt-4">
            {{ $t("instrHeader") }}
          </h5>
          <br />
          <ol>
            <li class="green-text">{{ $t("instrStep1") }}</li>
            <a href="#">
              <img v-if="!isMobile" width="10%" src="@/assets/tap.png" />
            </a>
            <li>{{ $t("instrStep2") }}</li>
            <li>{{ $t("instrStep3") }}</li>
          </ol>
          <div class="info-btn">
            <div style="display: inline-block">
              <IAMSmartButton
                v-if="show && isMobile"
                @click="iamsmartprofile"
                >{{ $t("iAmSmartMobileButton") }}</IAMSmartButton
              >
            </div>
          </div>
        </b-card>
      </div>
    </IAMSmartProfileResultProvider>
  </MainContent>
</template>
<script>
import MainContent from "../../../components/main/MainContent";
import LoginIAMSmartPendingView from "../../../locales/modules/login/views/LoginIAMSmartPendingView";

import { IAmSmartQrCodeApi, RequestRegistrationApi, MemberAccountInfoSettingApi } from "@/api";
import {
  IAMSmartProfileResultProvider,
  IAMSmartAuthApi,
  IAMSmartButton,
} from "@nextore/iam-smart";
export default {
  components: {
    IAMSmartProfileResultProvider,
  },
  props: {
    businessId: {
      tpye: String,
    },
    ecert: false,
    errorMsg: {},
    openIAmSmartAppUrl: {},
  },
  computed: {
    isMobile() {
      let ua = navigator.userAgent;
      let ipad = ua.match(/(iPad).*OS\s([\d_]+)/),
        isIphone = ua.match(/(iPhone\sOS)\s([\d_]+)/),
        isAndroid = ua.match(/(Android)\s+([\d.]+)/),
        isMobile = ipad || isIphone || isAndroid;
      return !!isMobile;
    },
  },
  data() {
    return {
      invitationCode: null,
      show: false,
      getIAmSmartUrl: '',
      userEngName:""
    };
  },
  async created() {
    this.ecert = this.$route.params.ecert;
    const getIAmSmartUrl = await IAmSmartQrCodeApi.getIAmSmartUrl();
    this.getIAmSmartUrl = getIAmSmartUrl.data.VUE_APP_IAM_SMART_APP_URL_SCHEME;
  },
  beforeMount(){
    var lang = this.$route.query.lang;
    if(lang) {
      this.$root.$i18n.locale = lang;
    }
  },
  methods: {
    async success({ businessId }) {
      console.log("success", businessId);
      this.redirect(this.invitationCode, businessId)
      //this.$successToast(this.$t("InvitationMsgTitle"), this.$t("sucessMsg"));
      //this.back();
      let lang = this.$i18n.locale.replace(/_/i, '-');
      await MemberAccountInfoSettingApi.editLanguage(lang);
      
    },
    error({ businessId, errorMsg }) {
      console.log("error", errorMsg);
      this.$dangerToast(this.$t("InvitationMsgTitle"), errorMsg);
      this.back();
    },
    async confirm() {
      var res = await RequestRegistrationApi.validateInvitationCode(
        this.invitationCode
      );
      if (res.data == "Valid") {
        if (!this.$route.params.ecert) {
          const reply = await IAmSmartQrCodeApi.RequestProfileForInvitation(
            this.businessId
          ); 
          if (reply.data = true) {
            this.redirect(this.invitationCode, this.businessId)
          }
          else {
            this.error(this.businessId)
          }
          // this.userEngName = reply.data?.userEngName;
          // this.userEngName = JSON.parse(reply.data.content).enName.UnstructuredName;
          // console.log(this.userEngName)
          // this.openIAmSmartAppUrl = `${process.env.VUE_APP_IAM_SMART_APP_URL_SCHEME}://profile?ticketID=${reply.data.getProfileRequestContent.ticketID}`;
          // this.openIAmSmartAppUrl = `${this.getIAmSmartUrl}://profile?ticketID=${reply.data.getProfileRequestContent.ticketID}`;
          //this.show = true;
        }
        else{
          this.redirect(this.invitationCode, null)
        }
      } else {
        this.$dangerToast(this.$t("InvitationMsgTitle"), this.$t("failCode"));
      }
      console.log("validateInvitationCode", res);
      console.log("invitationCode", this.invitationCode);
      console.log("businessId", this.businessId);
    },
    async iamsmartprofile() {
      document.location.href = this.openIAmSmartAppUrl;
    },
    back() {
      this.$router.push({
        name: "Login",
      });
    },
    async redirect(invitationCode, businessId,userEngName){
      let {data} = await RequestRegistrationApi.validateOwnerAssistant(invitationCode);
      console.log("redirect" , data)
      if (data == 'Helper') {
        this.$router.push({
          name: "ERegistrationHelperRegister",
          params: {
            invitationKey: invitationCode,
            businessId: businessId,
            // userEngName:userEngName
          },
        });
      } else if(data == 'Owner') {
        this.$router.push({
          name: "ERegistrationOwnerRegister",
          params: {
            invitationKey: invitationCode,
            businessId: businessId,
          },
        });
      }
    }
  },
  i18n: {
    messages: LoginIAMSmartPendingView,
  },
};
</script>
<style>
.green-text {
  color: #2b7366;
}

.header {
  background-color: #2b7366;
  color: white;
  font-size: 24px;
}

.info-header {
  text-align: center;
  background-color: #005d99;
  /*margin: auto;*/
}
.info-btn {
  text-align: center;
  margin-bottom: 30px;
}
.info-btn button {
  color: #fff;
  font-weight: 800;
  padding: 8px;
  border-radius: 0.25rem;
  background-color: #2b7366;
  border: none;
}
</style>

<i18n src="@/locales/actions.locale"></i18n>

<i18n src="@/public/locales/modules/login/views/LoginIAMSmartInvitationView.json" />